import React from 'react';
import AnchorNav from '../../platformui/AnchorNav';

export default (props) => {
  return <AnchorNav {...props} />;
};
